"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MARKING_TYPE", {
  enumerable: true,
  get: function () {
    return _Label.MARKING_TYPE;
  }
});
exports.SearchableSelect = exports.STYLE_TYPE = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _async = _interopRequireDefault(require("react-select/async"));
var _asyncCreatable = _interopRequireDefault(require("react-select/async-creatable"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _Label = require("b2b-components/theme/components/Form/Label");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _Error = require("../common/Error");
var _Info = require("../common/Info");
var _Control = require("./Control");
var _DropdownIndicator = require("./DropdownIndicator");
var _LoadingIndicator = require("./LoadingIndicator");
var _Option = require("./Option");
require("./SearchableSelect.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let STYLE_TYPE = exports.STYLE_TYPE = /*#__PURE__*/function (STYLE_TYPE) {
  STYLE_TYPE["outlined"] = "outlined";
  STYLE_TYPE["underlined"] = "underlined";
  return STYLE_TYPE;
}({});
const SearchableSelect = _ref => {
  let {
    searchableSelectId,
    className,
    onChange,
    options,
    onLoadOptions,
    onInputChange,
    error = null,
    info = null,
    isAsynchronous = false,
    isDisabled = false,
    isCreatable = false,
    markingType = _Label.MARKING_TYPE.none,
    maxMenuHeight,
    styleType = STYLE_TYPE.outlined,
    dropdownWidth,
    text = {
      creating: 'Creating',
      label: '',
      placeholder: '',
      noOptions: 'Not options found',
      required: '*',
      optional: '(optional)',
      loading: 'Loading...'
    },
    value = '',
    isValidNewOption,
    formatCreateLabel,
    onCreateOption
  } = _ref;
  const rootClassName = (0, _classnames.default)('cds-Form-Input', `cds-Form-Input--${(0, _upperCase.upperCaseFirst)(styleType)}`, {
    'cds-Form-Input--Error': error
  }, className);
  const selectOptions = [...(text.placeholder ? [{
    label: text.placeholder,
    value: null,
    isDisabled: true
  }] : []), ...options];
  const findValue = value === null ? null : options.find(option => option.value === value);
  const NoOptionsMessageComponent = props => /*#__PURE__*/_react.default.createElement(_reactSelect.components.NoOptionsMessage, props, text.noOptions);
  const formatCreateLabelInternal = userInput => `${text.creating || ''} "${userInput}"`;
  const commonProps = {
    searchableSelectId,
    defaultValue: findValue,
    value: findValue,
    isDisabled,
    options: selectOptions,
    className: 'cds-SearchableSelect',
    classNamePrefix: 'cds-SearchableSelect',
    onChange,
    onInputChange,
    isClearable: false,
    isSearchable: true,
    placeholder: text.placeholder,
    maxMenuHeight,
    components: {
      Control: _Control.Control,
      DropdownIndicator: _DropdownIndicator.DropdownIndicator,
      Option: _Option.Option,
      NoOptionsMessage: NoOptionsMessageComponent,
      IndicatorSeparator: null
    },
    styles: {
      menu: baseStyles => ({
        ...baseStyles,
        width: dropdownWidth || '100%'
      })
    },
    isValidNewOption,
    formatCreateLabel: formatCreateLabel || formatCreateLabelInternal,
    onCreateOption
  };
  const asyncProps = {
    defaultOptions: options.length > 0 ? options : false,
    cacheOptions: true,
    loadOptions: onLoadOptions,
    components: {
      ...commonProps.components,
      LoadingIndicator: _LoadingIndicator.LoadingIndicator
    },
    loadingMessage: () => text.loading
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, text.label && /*#__PURE__*/_react.default.createElement(_Label.Label, {
    text: text,
    markingType: markingType,
    className: "cds-Form-Label cds-SearchableSelect-Label",
    htmlFor: searchableSelectId
  }, text.label), isAsynchronous && isCreatable && /*#__PURE__*/_react.default.createElement(_asyncCreatable.default, (0, _extends2.default)({}, commonProps, asyncProps)), isAsynchronous && !isCreatable && /*#__PURE__*/_react.default.createElement(_async.default, (0, _extends2.default)({}, commonProps, asyncProps)), !isAsynchronous && isCreatable && /*#__PURE__*/_react.default.createElement(_creatable.default, commonProps), !isAsynchronous && !isCreatable && /*#__PURE__*/_react.default.createElement(_reactSelect.default, commonProps)), error && /*#__PURE__*/_react.default.createElement(_Error.Error, null, error), info && /*#__PURE__*/_react.default.createElement(_Info.Info, null, info));
};
exports.SearchableSelect = SearchableSelect;
//# sourceMappingURL=SearchableSelect.js.map